import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2"
}

import { computed, type HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import InputError from '@/components/InputError.vue';
    import { Label } from '@/components/ui/label';
    import { useI18n } from 'vue-i18n';

    interface Props {
        class?: HTMLAttributes['class'];
        form: any;
        name: string;
        label?: string;
        errorKey?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'InputRow',
  props: {
    class: {},
    form: {},
    name: {},
    label: {},
    errorKey: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const error = computed(() => props.form.errors?.[props.errorKey ?? props.name]);

    const label = computed(() => {
        return props.label ? t(props.label) : '';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('flex flex-col gap-2', props.class))
  }, [
    (label.value || _ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Label), { for: _ctx.name }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(label.value), 1)
            ]),
            _: 1
          }, 8, ["for"]),
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(cn)('slot-wrapper', { 'has-error': error.value }))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createVNode(InputError, { message: error.value }, null, 8, ["message"])
  ], 2))
}
}

})